appealsQuestions.classy.controller({
    name: 'iframeModalModalController',
    inject: ['$scope', '$sce', 'authServiceFactory', 'RestService', 'InformationService', 'PutService', 'PostService',
        'PurgeService', 'ModelService', 'AppealsModelService', 'SchoolModelService', 'StandardModalCudFactory', '$modalInstance'],
    init: function()
    {
        this.$.$modalInstance = this.$modalInstance;
        this.$.authServiceFactory = this.authServiceFactory;
        let domain = this.authServiceFactory.getDomain();
        this.$.previewURL = "https://" + domain + "/family_side/scSinApPreview.php?schoolID=" + this.authServiceFactory.getAuth().schoolID;
        this.$.previewURL = this.$sce.trustAsResourceUrl(this.$.previewURL);
    },
    dismiss: function(index)
    {

        if (typeof this.AppealsModelService.data[index].recordID == 'undefined') {
            this.AppealsModelService.data.pop();
        }
        this.$.$modalInstance.dismiss('cancel');
    }
});